const bodyScrollLock = require('body-scroll-lock');
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const enableBodyScroll = bodyScrollLock.enableBodyScroll;


"use strict";

if (!("ui" in window)) {
  window.ui = {};
}



// ********************
// DOM Variables
var uiRoot = document.body;
var uiMasthead = document.querySelector(".ui-masthead");
var uiHeader = document.querySelector(".ui-header");
var uiHeaderNavToggle = document.querySelector(".ui-header__nav-toggle");
var uiTray = document.querySelector(".ui-tray");
var uiTrayClose = document.querySelector(".ui-tray__close");
var uiTrayTabs = document.querySelectorAll(".ui-tray__tab");
var uiTrayMain = document.querySelector(".ui-tray__main");
var uiTrayPanels = document.querySelectorAll(".ui-tray__panel");
var uiSubheadMenuToggle = document.querySelector(".ui-subhead__menu-toggle");
var uiMenu = document.querySelector(".ui-menu");
var uiOverlay = document.querySelector(".ui-overlay");
var uiPlaceholder = document.querySelector(".ui-placeholder");
var uiSearch = document.querySelector(".ui-search");
var uiSearchToggle = document.querySelector(".ui-header__search-toggle");
var uiSearchBack = document.querySelector(".ui-search__back");
var uiSearchClear = document.querySelector(".ui-search__clear");
var uiSearchInput = document.querySelector(".ui-search__input");
var uiSearchForm = document.querySelector(".ui-search__form");
var uiSearchResults = document.querySelector(".ui-search__results");
var uiSearchSubmit = document.querySelector(".ui-search__submit");
var uiAnswerAsUserHiddenInput = document.querySelector("#answer_as_user");

// ********************
// Media Queries
var mediaMedium = window.matchMedia("(min-width: 768px)");
var mediaLarge = window.matchMedia("(min-width: 1024px)");
var mediaXlarge = window.matchMedia("(min-width: 1280px)");

// ********************
// Fastclick for mobile browsers
uiRoot.addEventListener("touchstart", function () {}, { passive: true });

// ********************
// Keyboard event helpers

// a11yclick
function a11yClick(event) {
  if (event.type === "click") {
    return true;
  } else if (event.type === "keypress") {
    if (event.key == " " || event.key === "Enter") {
      return true;
    }
  } else {
    return false;
  }
}

// escClick
function escKey(event) {
  return event.key == "Escape";
}

// ********************
// Resizing

var resizeTimer = null;

function doResize() {
  if (resizeTimer != null) {
    window.cancelAnimationFrame(window.ui.resizeTimer);
  }

  resizeTimer = window.requestAnimationFrame(function () {
    if (uiMasthead) {
      // Size the placeholder to the size of the header
      var mastheadHeight = uiMasthead.offsetHeight;
      uiPlaceholder.style.height = mastheadHeight + "px";
    }

    // Position the menu under the masthead
    if (uiMenu != null) {
      uiMenu.style.top = mastheadHeight + "px";
    }

    // Tray resizing
    if (uiTray) {
      if (mediaLarge.matches) {
        uiTray.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop + "px";
      } else {
        uiTray.style.maxHeight = null;
      }
    }

    // Search resizing
    if (uiSearch) {
      if (mediaMedium.matches) {
        uiSearch.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop - 16 + "px";
      } else {
        uiSearch.style.maxHeight = null;
      }
    }

    // Hide menus and such on screen size changes
    if (mediaLarge.matches) {
      closeNav();
      closeMenu();
    }

    // Remove the unsized flag (used to prevent content jitter)
    uiRoot.classList.remove("ui--unsized");

    // Clear the timer since we're done
    resizeTimer = null;
  });
}

doResize();

window.ui.resize = doResize;
window.addEventListener("resize", doResize, { passive: true });
window.addEventListener("load", doResize, { passive: true });
window.addEventListener("orientationchange", doResize, { passive: true });

// ********************
// Overlay - clicking the overlay always closes everything easy

function doOverlayClick(evt) {
  if (a11yClick(evt)) {
    closeNav();
    closeMenu();
    closeSearch();
    closeTray();
    evt.preventDefault();
  }
}

if (uiOverlay) {
  uiOverlay.addEventListener("click", doOverlayClick);
}

// ********************
// Nav

function isNavOpen() {
  return uiRoot.classList.contains("ui--nav-open");
}

function openNav() {
  if (isNavOpen()) {
    return;
  }

  closeMenu();
  closeSearch();
  closeTray();
  uiRoot.classList.add("ui--nav-open");
  document.addEventListener("keydown", doNavEsc);
}

function closeNav() {
  if (!isNavOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--nav-open");
  document.removeEventListener("keydown", doNavEsc);
}

function toggleNav() {
  if (isNavOpen()) {
    closeNav();
  } else {
    openNav();
  }
}

function doNavToggleClick(evt) {
  if (a11yClick(evt)) {
    toggleNav();
    evt.preventDefault();
  }
}

function doNavEsc(evt) {
  if (escKey(evt)) {
    closeNav();
    evt.preventDefault();
  }
}

window.ui.openNav = openNav;
window.ui.closeNav = closeNav;
window.ui.toggleNav = toggleNav;

if (uiHeaderNavToggle) {
  uiHeaderNavToggle.addEventListener("click", doNavToggleClick);
  uiHeaderNavToggle.addEventListener("keypress", doNavToggleClick);
}

// ********************
// Menu

function isMenuOpen() {
  return uiRoot.classList.contains("ui--menu-open");
}

function openMenu() {
  if (isMenuOpen()) {
    return;
  }

  closeNav();
  closeSearch();
  closeTray();
  uiRoot.classList.add("ui--menu-open");
  document.addEventListener("keydown", doMenuEsc);
}

function closeMenu() {
  if (!isMenuOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--menu-open");
  document.removeEventListener("keydown", doMenuEsc);
}

function toggleMenu() {
  if (isMenuOpen()) {
    closeMenu();
  } else {
    openMenu();
  }
}

function doMenuToggleClick(evt) {
  if (a11yClick(evt)) {
    toggleMenu();
    evt.preventDefault();
  }
}

function doMenuEsc(evt) {
  if (escKey(evt)) {
    closeMenu();
    evt.preventDefault();
  }
}

window.ui.openMenu = openMenu;
window.ui.closeMenu = closeMenu;
window.ui.toggleMenu = toggleMenu;

if (uiSubheadMenuToggle) {
  uiSubheadMenuToggle.addEventListener("click", doMenuToggleClick);
  uiSubheadMenuToggle.addEventListener("keypress", doMenuToggleClick);
}

// ********************
// Tray

function isTrayOpen() {
  return uiRoot.classList.contains("ui--tray-open");
}

function isTrayStuck() {
  return uiRoot.classList.contains("ui--tray-sticky") && mediaXlarge.matches;
}

var activeTrayPanel = null;

function openTray(name) {
  if (name === null) {
    return closeTray();
  }

  closeNav();
  closeMenu();
  closeSearch();

  activateTray(name);

  if (!isTrayStuck()) {
    uiRoot.classList.add("ui--tray-open");
    document.addEventListener("keydown", doTrayEsc);

    if (!mediaLarge.matches) {
      bodyScrollLock.disableBodyScroll(activeTrayPanel);
    }
  }
}

function activateTray(name) {
  uiTrayTabs.forEach(function (tab) {
    if (tab.dataset.tray === name) {
      tab.classList.add("ui-tray__tab--active");
    } else {
      tab.classList.remove("ui-tray__tab--active");
    }
  });

  uiTrayPanels.forEach(function (panel) {
    if (panel.dataset.tray === name) {
      panel.classList.add("ui-tray__panel--active");
      activeTrayPanel = panel;
    } else {
      panel.classList.remove("ui-tray__panel--active");
    }
  });
}

function loadTrayPanel(panel) {
  var url = panel.dataset.url;
  if (!url) {
    return;
  }

  panel.classList.add("ui-tray__panel--loading");

  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.onload = function () {
    if (xhr.status === 200) {
      // Create replacement DIV
      var newPanel = document.createElement("div");
      newPanel.innerHTML = xhr.responseText;
      newPanel = newPanel.children[0];
      newPanel.removeAttribute("data-url");

      // Keeps active if currently active
      if (panel.classList.contains("ui-tray__panel--active")) {
        newPanel.classList.add("ui-tray__panel--active");
      }

      // Hide any loading or error states
      newPanel.classList.remove("ui-tray__panel--loading");
      newPanel.classList.remove("ui-tray__panel--error");

      // put into the dom
      uiTrayMain.replaceChild(newPanel, panel);
      panel = null;

      // refresh the panels
      uiTrayPanels = document.querySelectorAll(".ui-tray__panel");

      // TODO? Tooltips
      window.ui.initTooltips();
    } else {
      panel.classList.remove("ui-tray__panel--loading");
      panel.classList.add("ui-tray__panel--error");
    }

    updateTrayCounts();
  };

  xhr.send();
}

function updateTrayCounts() {
  var unreads = {};
  var alert = false;

  uiTrayPanels.forEach(function (panel) {
    if (panel.hasAttribute("data-unread")) {
      unreads[panel.dataset.tray] = true;
    }
    if (panel.hasAttribute("data-alert")) {
      alert = true;
    }
  });

  uiTrayTabs.forEach(function (tab) {
    if (unreads[tab.dataset.tray] === true) {
      tab.setAttribute("data-unread", "");
    } else {
      tab.removeAttribute("data-unread");
    }

    if (tab.dataset.tray === "notifications" && alert === true) {
      tab.setAttribute("data-alert", "");
    } else {
      tab.removeAttribute("data-alert");
    }
  });
}

function closeTray() {
  if (!isTrayOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--tray-open");
  document.removeEventListener("keydown", doTrayEsc);
  bodyScrollLock.clearAllBodyScrollLocks();
}

function doTrayTabClick(evt) {
  if (a11yClick(evt)) {
    openTray(evt.target.dataset.tray);
    evt.preventDefault();
  }
}

function doTrayCloseClick(evt) {
  if (a11yClick(evt)) {
    closeTray();
    evt.preventDefault();
  }
}

function doTrayEsc(evt) {
  if (escKey(evt)) {
    closeTray();
    evt.preventDefault();
  }
}

window.ui.openTray = openTray;
window.ui.closeTray = closeTray;

// Make sure notifications is activated
if (uiTray) {
  uiTrayTabs.forEach(function (tab) {
    tab.addEventListener("click", doTrayTabClick);
    tab.addEventListener("keypress", doTrayTabClick);
  });

  uiTrayPanels.forEach(function (panel) {
    loadTrayPanel(panel);
  });

  uiTrayClose.addEventListener("click", doTrayCloseClick);
  uiTrayClose.addEventListener("keypress", doTrayCloseClick);

  // Activate the first available tray, or notifications
  if (uiTrayTabs[0]) {
    activateTray(uiTrayTabs[0].dataset.tray);
  } else {
    activateTray("notifications");
  }
}

// ********************
// Search

var searchSavedQuery = "";
var searchCache = {};
var feedbackCache = {};
var pendingQuery = null;

function doSearchEsc(evt) {
  if (escKey(evt)) {
    closeSearch();
    evt.preventDefault();
  }
}

function openSearch(query, scope) {
  closeNav();
  closeMenu();
  closeTray();

  uiRoot.classList.add("ui--search-open");
  uiSearchInput.value = searchSavedQuery;
  preloadAnswerData();

  bodyScrollLock.disableBodyScroll(uiSearchResults);
  document.addEventListener("keydown", doSearchEsc);
  window.ui.initTooltips();
}

function preloadAnswerData() {
  if (!uiSearch.classList.contains("ui-search--answers-enabled") || uiSearch.classList.contains("ui-search--answers-preloaded")) {
    return;
  }
  uiSearch.classList.add("ui-search--answers-preloaded");
  var preloadUrl = uiSearch.dataset.preloadUrl;
  var xhrRequest = new XMLHttpRequest();
  xhrRequest.open("POST", preloadUrl);
  xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  var csrfToken = document.querySelector("meta[name=csrf-token]");
  if (csrfToken) {
    xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
  }
  xhrRequest.send();
}

function closeSearch() {
  uiRoot.classList.remove("ui--search-open");
  searchSavedQuery = searchQuery();
  uiSearchInput.value = "";
  bodyScrollLock.clearAllBodyScrollLocks();
  document.removeEventListener("keydown", doSearchEsc);
}

function isSearchQueryBlank() {
  return searchQuery() === "";
}

function searchQuery() {
  return uiSearchInput.value.replace(/\s+/g, " ").trim();
}

function searchQueryCacheKey() {
  return searchQuery() + "|" + (uiAnswerAsUserHiddenInput?.value || "");
}

function searchResultsUrl(query) {
  var url = uiSearchForm.dataset.url;

  var params = new URLSearchParams();
  params.set("query", query);
  params.set("answer_as_user", uiAnswerAsUserHiddenInput?.value);
  url = url + "?" + params.toString();

  return url;
}

var searchXHR = null;

function loadSearchResults() {
  var activeQuery = searchQuery();
  var activeQueryCacheKey = searchQueryCacheKey();

  if (searchCache[activeQueryCacheKey] != null) {
    // console.log('[HIT]  Showing results for:', activeQuery)
    uiSearchResults.innerHTML = searchCache[activeQueryCacheKey];
    uiSearch.classList.remove("ui-search--loading");
    if (feedbackCache[activeQueryCacheKey] === true) {
      uiSearch.classList.add("ui-search--feedback-completed");
    } else {
      uiSearch.classList.remove("ui-search--feedback-completed", "ui-search--feedback-no-reasons");
    }
  } else {
    if (pendingQuery == activeQuery) {
      return;
    }

    if (searchXHR != null) {
      searchXHR.abort();
    }

    uiSearch.classList.add("ui-search--loading");
    var resultsURL = searchResultsUrl(activeQuery);
    // console.log('[MISS] Fetching results for:', activeQuery, resultsURL)

    pendingQuery = activeQuery;

    searchXHR = new XMLHttpRequest();
    searchXHR.open("GET", resultsURL);
    searchXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    searchXHR.onload = function () {
      if (searchXHR.status === 200) {
        searchCache[activeQueryCacheKey] = searchXHR.responseText;
        loadSearchResults();

        // remove from pending
        pendingQuery = null;
      }
    };

    searchXHR.send();
  }
  window.ui.initTooltips();
}

function clearSearchQuery() {
  uiSearchInput.value = "";
  searchSavedQuery = "";
  uiSearchInput.focus();
  loadSearchResults();
  uiSearch.classList.remove("ui-search--query");
}

function doSearchBackClick(evt) {
  if (a11yClick(evt)) {
    closeSearch();
    evt.preventDefault();
  }
}

function doSearchClearClick(evt) {
  if (a11yClick(evt)) {
    clearSearchQuery();
    evt.preventDefault();
  }
}

function doSearchInputClick(evt) {
  if (a11yClick(evt)) {
    openSearch(null, null);
    evt.preventDefault();
  }
}

function doSearchInputKeypress(evt) {
  if (evt.key == "Enter") {
    evt.preventDefault();
    updateSearch();
  }

  if (a11yClick(evt) && isSearchQueryBlank()) {
    openSearch(null, null);
    evt.preventDefault();
  }
}

function doSearchSubmitClick(evt) {
  if (a11yClick(evt)) {
    updateSearch();
    evt.preventDefault();
  }
}

function updateSearch() {
  searchSavedQuery = searchQuery();

  doSearchInputInput();
  loadSearchResults();
}

function doSearchInputInput(evt) {
  if (isSearchQueryBlank()) {
    uiSearch.classList.remove("ui-search--query");
  } else {
    uiSearch.classList.add("ui-search--query");
  }
}

function doFeedbackLinkClick(evt) {
  var evtTargetFeedbackLink = evt.target.closest(".answer-feedback__link--rate");
  if (evtTargetFeedbackLink) {
    if (evtTargetFeedbackLink.classList.contains("answer-feedback__link--clicked")) {
      return;
    }
    if (uiSearch.classList.contains("ui-search--loading")) {
      return;
    }
    evt.preventDefault();
    evtTargetFeedbackLink.classList.add("answer-feedback__link--clicked");
    var feedbackUrl = evtTargetFeedbackLink.dataset.url;
    if (!feedbackUrl) {
      return;
    }
    var feedbackShowNoReasons = evtTargetFeedbackLink.dataset.showNoReasons !== undefined;

    var feedbackXHR = new XMLHttpRequest();
    feedbackXHR.open("POST", feedbackUrl);
    feedbackXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      feedbackXHR.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }

    feedbackXHR.onload = function () {
      if (feedbackXHR.status === 200) {
        uiSearch.classList.remove("ui-search--feedback-no-reasons");

        if (feedbackShowNoReasons === true) {
          uiSearch.classList.add("ui-search--feedback-no-reasons");
        } else {
          uiSearch.classList.add("ui-search--feedback-completed");
        }
        feedbackCache[searchQueryCacheKey()] = true;
      }
    };

    feedbackXHR.send();
  }
}

function doFeaturePreferenceClick(evt) {
  if (uiSearch.classList.contains("ui-search--loading")) {
    return;
  }
  var evtTargetPreferenceLink = evt.target.closest(".search-answer-preference-button");
  var evtTargetPreferenceToggle = evt.target.closest(".toggle-switch");
  if (evtTargetPreferenceLink) {
    var preferenceUrl = evtTargetPreferenceLink.dataset.url;
    if (!preferenceUrl) {
      return;
    }
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open("POST", preferenceUrl);
    xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }

    xhrRequest.onload = function () {
      if (xhrRequest.status === 200) {
        uiSearch.classList.add("ui-search--answer-preference-saved");
        window.location.reload();
      }
    }
    xhrRequest.send();
  } else if (evtTargetPreferenceToggle) {
    if (evtTargetPreferenceToggle.classList.contains("toggle-switch--processing")) {
      return;
    }
    evtTargetPreferenceToggle.classList.add("toggle-switch--processing");
    var settingsDiv = evtTargetPreferenceToggle.closest('.search-answer-setting')
    if (settingsDiv) {
      var currentlyEnabled = settingsDiv.classList.contains("search-answer-preference--on");
      var form = settingsDiv.querySelector('#search-answer-preference-form');
      var xhrRequest = new XMLHttpRequest();
      xhrRequest.open(form.method, form.action);
      xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhrRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      var csrfToken = document.querySelector("meta[name=csrf-token]");
      if (csrfToken) {
        xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
      }
      xhrRequest.onload = function () {
        if (xhrRequest.status === 200) {
          settingsDiv.classList.toggle("search-answer-preference--on");
          evtTargetPreferenceToggle.classList.remove("toggle-switch--processing");
          if (uiSearch.classList.contains("ui-search--query")) {
            searchCache = {}; // Clear the search cache to allow the same search term to be reloaded
            updateSearch();
          }
        }
      }

      xhrRequest.send('opt_in=' + (currentlyEnabled ? '0' : '1'));
    }
  }
}

function trackStandaloneMode() {
  if (window.navigator.standalone) {
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open("POST", "/_ui/standalone");
    xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }
    xhrRequest.send();
  }
}

trackStandaloneMode();

if (uiSearch) {
  loadSearchResults();

  uiSearchResults.addEventListener("click", doFeedbackLinkClick);
  uiSearchResults.addEventListener("click", doFeaturePreferenceClick);

  uiSearchBack.addEventListener("click", doSearchBackClick);
  uiSearchBack.addEventListener("keypress", doSearchBackClick);

  uiSearchInput.addEventListener("click", doSearchInputClick);
  uiSearchInput.addEventListener("keypress", doSearchInputKeypress);

  uiSearchToggle.addEventListener("click", doSearchInputClick);
  uiSearchToggle.addEventListener("keypress", doSearchInputClick);

  uiSearchClear.addEventListener("click", doSearchClearClick);
  uiSearchClear.addEventListener("keypress", doSearchClearClick);

  uiSearchSubmit.addEventListener("click", doSearchSubmitClick);
  uiSearchSubmit.addEventListener("keypress", doSearchSubmitClick);

  uiSearchInput.addEventListener("input", doSearchInputInput);

  uiSearch.addEventListener("change", function(evt) {
    if (evt.target.id === "select_answer_as_user") {
      uiAnswerAsUserHiddenInput.value = evt.target.value;
    }
  });
}

window.ui.openSearch = openSearch;
